import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2Check: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-2-check, valid"} maskId="square-filled-radius-0-stroke-1-IconEmail2Check"><path d="M22 4V7.55664L21.7266 7.69629L12.2266 12.5176L12 12.6318L11.7734 12.5176L3 8.06348V19H12V20H2V4H22Z" fill="currentColor"/><path d="M22.8965 13.3047L17.5488 20.2559L14.6465 17.3535L15.3535 16.6465L17.4502 18.7432L22.1035 12.6953L22.8965 13.3047Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail2Check;
